const LEASING_COMPANY_ACTION_TYPES = Object.freeze({
  FETCH_DATA_LEASING_COMPANIES: 'FETCH_DATA_LEASING_COMPANIES',
});

export default LEASING_COMPANY_ACTION_TYPES;
